import { useState } from "react";
import { RotateCcw, RotateCw, ExternalLink } from "lucide-react";
import { Button } from "Components/Button";
import { DocumentItem } from "./DocumentItem";
import { useItemsContext } from "../../hooks/useItemsContext";

interface DocumentsProps {
  files: { file_path: string }[] | undefined;
}

export const Documents = ({ files }: DocumentsProps) => {
  const [tabSelected, setTabSelected] = useState(1);
  const [rotations, setRotations] = useState<{ [key: string]: number }>({});
  const { fileBlobs, isLoadingFiles } = useItemsContext();

  const currentFileView = files?.[tabSelected - 1];
  const currentFileBlob = currentFileView
    ? fileBlobs[currentFileView.file_path]
    : null;

  const currentRotation = currentFileView
    ? rotations[currentFileView.file_path] || 0
    : 0;

  const handleRotateLeft = () => {
    if (currentFileView) {
      setRotations((prev) => ({
        ...prev,
        [currentFileView.file_path]:
          (prev[currentFileView.file_path] || 0) - 90,
      }));
    }
  };

  const handleRotateRight = () => {
    if (currentFileView) {
      setRotations((prev) => ({
        ...prev,
        [currentFileView.file_path]:
          (prev[currentFileView.file_path] || 0) + 90,
      }));
    }
  };

  const handleOpenOriginalLink = () => {
    if (currentFileView?.file_path) {
      window.open(currentFileView.file_path, "_blank");
    }
  };

  return (
    <div className="documents-preview-style">
      <div className="tabs">
        <div className="tabs-left">
          {files?.map((file, index) => (
            <Button
              key={file.file_path}
              onClick={() => setTabSelected(index + 1)}
              outlined
              {...(index + 1 === tabSelected && { outlined: false })}
            >
              Arquivo {index + 1}
            </Button>
          ))}
        </div>
        <div className="tabs-right">
          <Button onClick={handleRotateLeft} outlined>
            <RotateCcw size={16} />
            <span>Girar Esquerda</span>
          </Button>
          <Button onClick={handleRotateRight} outlined>
            <RotateCw size={16} />
            <span>Girar Direita</span>
          </Button>
          <Button
            onClick={handleOpenOriginalLink}
            outlined
            disabled={!currentFileView?.file_path}
          >
            <ExternalLink size={16} />
            <span>Abrir Link</span>
          </Button>
        </div>
      </div>

      <div className="documents-preview">
        {currentFileView && (
          <DocumentItem
            fileBlob={currentFileBlob}
            isLoading={isLoadingFiles}
            rotation={currentRotation}
          />
        )}
      </div>
    </div>
  );
};
